import {
  styled,
  ToggleButton,
  toggleButtonClasses,
  Badge,
} from "@mui/material";
import { type PropsWithChildren, type ReactNode } from "react";

import type { SearchScope } from "@/types/types";

const StyledToggleButton = styled(ToggleButton)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "calc(var(--spacing)*2)",
  border: "none !important",
  textTransform: "none",
  color: "var(--color-text-interactive) !important",
  fontWeight: "500 !important",
  fontSize: "14px",
  letterSpacing: "0",
  lineHeight: "20px",
  borderRadius: "var(--radius-2xl) !important",
  margin: "0 !important",
  padding: "calc(var(--spacing)*2) !important",
  width: "80px",
  backgroundColor: "var(--color-white)",
  transition: "transform 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
    backgroundColor: "var(--color-white)",
  },
  [`&.${toggleButtonClasses.selected}`]: {
    transform: "scale(1.1)",
    backgroundColor: "var(--color-white)",
    "&:hover": {
      backgroundColor: "var(--color-white)",
    },
  },
}));

type ScopeSwitcherButtonProps = PropsWithChildren<{
  value: SearchScope;
  badgeContent?: ReactNode;
}>;

export const ScopeSwitcherButton = ({
  value,
  badgeContent,
  children,
}: ScopeSwitcherButtonProps) => {
  const button = (
    <StyledToggleButton value={value}>{children}</StyledToggleButton>
  );

  return badgeContent ? (
    <Badge
      color="primary"
      badgeContent={badgeContent}
      sx={{
        ".MuiBadge-badge": {
          background: "linear-gradient(103deg, #93FFD4 0%, #0F9 100%)",
          px: "calc(var(--spacing)*2)",
          py: "calc(var(--spacing)*0.5)",
          color: "var(--color-text-interactive)",
          fontWeight: 400,
          fontSize: "var(--text-xs)",
          lineHeight: "var(--tw-leading, var(--text-xs--line-height))",
          height: "auto",
        },
      }}
    >
      {button}
    </Badge>
  ) : (
    button
  );
};
